import { ConnectionStatus, Network } from '@capacitor/network';
import { Injectable, inject } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { ToastController, ToastOptions } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { unbindPluginListeners } from 'src/app/@shared/app-helper';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private connectionStatus: ConnectionStatus;
  private toastElement: HTMLIonToastElement;
  private toastMessage: string;

  private pluginListeners: { [key: string]: PluginListenerHandle } = {};

  private toastController = inject(ToastController);
  private translate = inject(TranslateService);

  public init(): void {
    this.translate.get('VIEW.COMMON.TOAST.OFFLINE.MESSAGE').subscribe((message: string) => {
      this.toastMessage = message;
      this.oberveConnection().catch();
    });
  }

  public ngOnDestroy(): void {
    unbindPluginListeners(this.pluginListeners);
  }

  private async oberveConnection(): Promise<void> {
    this.connectionStatus = await Network.getStatus();
    this.onNetworkStatusReceived();

    return this.bindPluginListeners();
  }

  private onNetworkStatusReceived(): void {
    if (this.connectionStatus.connectionType === 'none') {
      this.showToast().catch();
    } else {
      this.hideToast().catch();
    }
  }

  private async showToast(): Promise<void> {
    await this.hideToast();

    const toastOptions: ToastOptions = {
      buttons: [
        {
          icon: 'close-outline',
          role: 'cancel',
          side: 'end',
        },
      ],
      color: 'danger',
      cssClass: 'proto-toast error',
      message: this.toastMessage,
      position: 'top',
    };

    this.toastElement = await this.toastController.create(toastOptions);

    return this.toastElement.present();
  }

  private async hideToast(): Promise<void> {
    if (this.toastElement) {
      await this.toastElement.dismiss();
    }
  }

  private async bindPluginListeners(): Promise<void> {
    let timer: ReturnType<typeof setTimeout>;
    const t = 1000;

    this.pluginListeners.networkStatusChange = await Network.addListener('networkStatusChange', (status) => {
      // prevent networkStatusChange firing too fast in a row
      clearTimeout(timer);
      timer = setTimeout(() => {
        this.connectionStatus = status;
        this.onNetworkStatusReceived();
      }, t);
    });

    return Promise.resolve();
  }
}
